import ReportsModuleCard from './container'
export default ReportsModuleCard
